import Request from './request'

const Device_Rpc = {
  getRPCInfo (id, callback) {
    Request.get('device-rpc/index/' + id).then(callback).catch(this.bad_answer)
  },
  runRPCCommand (id, params, callback) {
    Request.post('device-rpc/run/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  checkRPCCommand (id, callback) {
    Request.get('device-rpc/get-cmd/' + id).then(callback).catch(this.bad_answer)
  },
}
export default Device_Rpc
